import angular from 'angular';

angular
  .module('cxTaskflow')
  .controller('DeleteAssignmentDialogCtrl', [
    '$element',
    '$q',
    'translateListFilter',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'invoiceStreamId',
    'relationId',
    deleteAssignmentDialogCtrl,
  ]);

function deleteAssignmentDialogCtrl(
  $element,
  $q,
  translateListFilter,
  $http,
  appUrls,
  flySvc,
  close,
  invoiceStreamId,
  relationId,
) {
  var vm = this;
  vm.updateRegistrations = true;
  vm.deleting = false;
  vm.loading = true;
  //To show which relation use this assignment for invoicing via
  vm.viaRelations = [];
  vm.hasRegistrations = false;
  vm.updateRegistrations = false;

  vm.taskSchedules = [];
  var scheduleRequest = $http
    .get(`${appUrls.tasks}/Api/TaskSchedules?relationId=${relationId}`)
    .then(({ data }) => {
      vm.taskSchedules = data
        .filter(x => x.invoiceStreamId === invoiceStreamId)
        .map(
          x =>
            `${translateListFilter(
              x.template.id,
              'tasktemplate',
              x.template.name,
            )} - ${translateListFilter(x.periodicity.id, 'taskperiodicity', x.periodicity.name)}`,
        )
        .sort();
    });
  var registrationRequest = $http
    .get(`${appUrls.api}/Api/Registration/Get`, {
      params: {
        invoiceStreamId,
        take: 1,
        page: 0,
        filter: { invoiceStatus: { items: [0] }, neverInvoice: { items: [false] } },
      },
    })
    .then(({ data = {} }) => {
      const { registrations = [] } = data;
      vm.hasRegistrations = registrations.length > 0;
    });
  $q.all([scheduleRequest, registrationRequest]).then(function() {
    if (vm.taskSchedules.length === 0) vm.loading = false;
  });

  vm.delete = function() {
    if (vm.deleting) return;
    vm.deleting = true;

    $http
      .delete(`${appUrls.api}/api/InvoiceStream/Delete/${invoiceStreamId}`, {
        params: {
          updateRegistrations: vm.updateRegistrations,
        },
      })
      .then(
        () => {
          $element.modal('hide');
          close(true, 500);
          flySvc.success();
          vm.deleting = false;
        },
        function(error) {
          vm.deleting = false;
          if (error) {
            var code = error.code || (error.data && error.data.code);
            if (code === 2073) {
              // NotAllowedDeleteInvoiceStreamUsedForInvoicingVia
              var params = error.parameters || error.data.parameters || [];
              if (params.length > 0 && params[0].indexOf('[') === 0) {
                vm.viaRelations = JSON.parse(params[0]);
              }
            }
          }

          flySvc.error(error);
        },
      );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
